import { render, staticRenderFns } from "./KnFormSupplier.vue?vue&type=template&id=3747fc6d"
import script from "./KnFormSupplier.js?vue&type=script&lang=js&external"
export * from "./KnFormSupplier.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports